import { render, staticRenderFns } from "./UserFloatingChat.vue?vue&type=template&id=c55d60ce&scoped=true"
import script from "./UserFloatingChat.vue?vue&type=script&lang=js"
export * from "./UserFloatingChat.vue?vue&type=script&lang=js"
import style0 from "./UserFloatingChat.vue?vue&type=style&index=0&id=c55d60ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55d60ce",
  null
  
)

export default component.exports